import { makeVar } from "@apollo/client";
import { DefaultWorklistASAMs } from "enums/Methods";
import {
  ExternalThawStep,
  SelectionProcess,
} from "features/WorklistTools/shared/interfaces"; //TODO: Refactor to share across tools
import { WellSelection } from "../../shared/interfaces";
import { SeedingStrategy } from "./../../shared/interfaces";

export interface IExternalThawInternalState {
  uploadedWorklist: boolean;
  destSelectionProcess: SelectionProcess;
  randomizeWells: boolean;
  selectedSourceWells: WellSelection[];
  selectedIntToDestWells: WellSelection[];
  selectedInt1Wells: WellSelection[];
  step: ExternalThawStep;
  selectedDestinationIndex?: number;
  requiredWarnings: string[];
  optionalWarnings: string[];
  worklist: any[];
  worklistPreviewOpen: boolean;
  hoverWellId: string;
  sourcePlateHasTubeBarcodeScan: boolean;
  methodSettings: IExternalThawMethodSettings;
}

export interface IExternalThawMethodSettings {
  selectedSystem: number;
  arraySystemAutomationMethodId: number;
  numberOfAliquots: number;
  aliquotVolume: number;
  spinParamGForce: number;
  spinParamPercent: number;
  spinTime: number;
  spinAccel: number;
  spinDecel: number;
  defaultVSpinSettings: boolean;
  seedingStrategy: SeedingStrategy;
  splitSeedingVolEvenly: boolean;
  experimentSettings: string;
  batchDestPlates: boolean;
  incubationTime: number;
}

export const ExternalThawInternalState = makeVar<IExternalThawInternalState>({
  uploadedWorklist: false,
  destSelectionProcess: SelectionProcess.Stamp,
  randomizeWells: false,
  selectedSourceWells: [],
  selectedIntToDestWells: [], // used for int to dest selection
  selectedInt1Wells: [],
  step: ExternalThawStep.SelectSourceToIntermediate,
  selectedDestinationIndex: undefined,
  requiredWarnings: [],
  optionalWarnings: [],
  worklist: [],
  worklistPreviewOpen: false,
  hoverWellId: "",
  sourcePlateHasTubeBarcodeScan: false,
  methodSettings: {
    selectedSystem: 0,
    arraySystemAutomationMethodId: DefaultWorklistASAMs.ExternalThaw,
    numberOfAliquots: 0,
    aliquotVolume: 0,
    spinParamGForce: 252,
    spinParamPercent: 50,
    spinTime: 6,
    spinAccel: 50,
    spinDecel: 5,
    defaultVSpinSettings: true,
    seedingStrategy: SeedingStrategy.CellCount,
    splitSeedingVolEvenly: false,
    experimentSettings: "",
    batchDestPlates: false,
    incubationTime: 0,
  },
});
